import { SvgIcon, SvgIconProps, SxProps, Theme } from '@mui/material';

const customStyles = {
  // The drawing carries its own fills, so the icon must not tint them with the
  // surrounding text colour the way a monochrome icon would.
  fill: { fill: 'none' },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Empty state illustration for the meter reading history (DS-3770). Comes from the
 * `chart.svg` handed over with the design reference and is used as provided: not
 * redrawn, not reinterpreted. The viewBox keeps the original 200x200 proportion.
 */
export function MeterHistoryEmptyStateIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 200 200'
      sx={[customStyles.fill, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}
    >
      <path
        d='M138.896 165.318C99.0431 155.449 68.7916 213.113 29.009 181.621C-6.41074 153.583 22.8214 138.335 4.85653 81.5586C-13.1084 24.7819 58.5627 -7.95755 82.5524 18.0598C106.542 44.0772 150.705 32.3025 173.05 56.9322C226.24 115.56 182.561 171.894 138.896 165.318Z'
        fill='#D8EFFE'
      />
      <rect
        width='130.332'
        height='99.6455'
        rx='8'
        transform='matrix(-1 0 0 1 169.965 54.5273)'
        fill='#6DB1FB'
      />
      <rect
        width='131.862'
        height='100.852'
        rx='8'
        transform='matrix(-1 0 0 1 163.234 45.043)'
        fill='white'
        stroke='#0B2777'
      />
      <path
        d='M58.9297 126.121C58.9297 125.017 59.8251 124.121 60.9297 124.121H67.4789C68.5834 124.121 69.4789 125.017 69.4789 126.121V145.471H58.9297V126.121Z'
        fill='#E88E0F'
      />
      <path
        d='M75.7617 110.051C75.7617 108.946 76.6571 108.051 77.7617 108.051H84.3109C85.4155 108.051 86.3109 108.946 86.3109 110.051V145.475H75.7617V110.051Z'
        fill='#0B2777'
      />
      <path
        d='M92.5898 100.008C92.5898 98.9032 93.4853 98.0078 94.5898 98.0078H101.39C102.495 98.0078 103.39 98.9032 103.39 100.008V145.479H92.5898V100.008Z'
        fill='#0B2777'
      />
      <path
        d='M109.676 90.7109C109.676 89.6064 110.571 88.7109 111.676 88.7109H118.225C119.33 88.7109 120.225 89.6064 120.225 90.7109V145.476H109.676V90.7109Z'
        fill='#6DB1FB'
      />
      <path
        d='M126.504 80.6641C126.504 79.5595 127.399 78.6641 128.504 78.6641H135.053C136.158 78.6641 137.053 79.5595 137.053 80.6641V145.475H126.504V80.6641Z'
        fill='#3E8FFA'
      />
      <path
        d='M55.4213 109.214C56.1653 110.485 57.7988 110.913 59.0698 110.169C60.3408 109.425 60.768 107.791 60.024 106.52C59.28 105.249 57.6465 104.822 56.3755 105.566C55.1045 106.31 54.6773 107.943 55.4213 109.214ZM57.7227 107.867L57.9752 108.299L81.3172 94.6351L81.0646 94.2036L80.812 93.7721L57.4701 107.436L57.7227 107.867Z'
        fill='#1D39C4'
      />
      <path
        d='M79.5182 96.3371C80.7745 97.1058 82.416 96.7106 83.1847 95.4544C83.9535 94.1982 83.5583 92.5566 82.3021 91.7879C81.0458 91.0192 79.4043 91.4144 78.6356 92.6706C77.8668 93.9268 78.262 95.5684 79.5182 96.3371ZM80.9102 94.0625L81.3366 94.3235L93.0076 75.2514L92.5811 74.9904L92.1546 74.7295L80.4837 93.8015L80.9102 94.0625Z'
        fill='#1D39C4'
      />
      <path
        d='M90.2826 74.7852C90.2826 76.2579 91.4765 77.4518 92.9492 77.4518C94.422 77.4518 95.6159 76.2579 95.6159 74.7852C95.6159 73.3124 94.422 72.1185 92.9492 72.1185C91.4765 72.1185 90.2826 73.3124 90.2826 74.7852ZM115.902 74.7852C115.902 76.2579 117.096 77.4518 118.568 77.4518C120.041 77.4518 121.235 76.2579 121.235 74.7852C121.235 73.3124 120.041 72.1185 118.568 72.1185C117.096 72.1185 115.902 73.3124 115.902 74.7852ZM92.9492 74.7852V75.2852H118.568V74.7852V74.2852H92.9492V74.7852Z'
        fill='#1D39C4'
      />
      <path
        d='M135.647 57.9307C136.689 58.9721 138.377 58.9721 139.419 57.9307C140.46 56.8894 140.46 55.2009 139.419 54.1595C138.377 53.1181 136.689 53.1181 135.647 54.1595C134.606 55.2009 134.606 56.8894 135.647 57.9307ZM118.461 75.1172L118.814 75.4707L137.887 56.3987L137.533 56.0451L137.179 55.6916L118.107 74.7636L118.461 75.1172Z'
        fill='#1D39C4'
      />
    </SvgIcon>
  );
}
